const author = "Sandip Gyawali";
const title = "Sandip Gyawali";
const username = "SandipGyawali";
const linkedinUsername = "sandip-gyawali-615681211";
const host = "sandip-dev.vercel.app";
const url = "https://" + host;
const mail = "sandipgyawali100@gmail.com";
const description = `${author}. Explore my personal portfolio, services and blogs.`;
const og = `${url}/og.png`;
const shortAbout =
  "CS/IT @Ascol | Full-Stack Developer & Builder | Exploring Startups.";
const about =
  "Currently interested on developing quality applications as solutions that effectively solve problems, rather than just providing solutions.";

export {
  about,
  author,
  description,
  host,
  linkedinUsername,
  mail,
  og,
  shortAbout,
  title,
  url,
  username,
};
